export const EVENT_IDS = {
  ClickLeaseExpiryIcon: 193,
  ClickLeaseFromLeaseExpiryPage: 194,
  changeStatusOfLeaseExpiry: 195,
  CloneAndCreateNewCreated: 196,
};
